import React, { useEffect, useState } from "react";
import api from "../api";
import toast from 'react-hot-toast';
import MainLayout from "./MainLayout";
import { useAuth } from "../context/AuthContext";
import TopNavBar from  "./TopNavBar";
export default function PreferencesPage() {
  const { user, logout } = useAuth();

  const [roles, setRoles] = useState([]);
  const [allMenus, setAllMenus] = useState([]);

  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedMenus, setSelectedMenus] = useState([]);

  const [isCreateMode, setIsCreateMode] = useState(false);
  const [newRoleName, setNewRoleName] = useState("");

  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifications] = useState(0);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    try {
      const rolesRes = await api.get("/api/roles");
      const menusRes = await api.get("/api/menus/all");

      setRoles(rolesRes.data);
      setAllMenus(menusRes.data);
    } catch {
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const handleRoleClick = async (roleName) => {
    try {
      setIsCreateMode(false);
      setSelectedRole(roleName);

      const res = await api.get(`/api/menus/role/${roleName}`);
      setSelectedMenus(res.data);
    } catch {
      toast.error("Failed to load role menus");
    }
  };

  const handleCreateClick = () => {
    setIsCreateMode(true);
    setSelectedRole(null);
    setSelectedMenus([]);
    setNewRoleName("");
  };

  const handleToggle = (menuName) => {
    setSelectedMenus((prev) =>
      prev.includes(menuName)
        ? prev.filter((m) => m !== menuName)
        : [...prev, menuName]
    );
  };

  const handleSaveRole = async () => {
    try {
      await api.put("/api/menus/update-role-menus", {
        role: selectedRole,
        menus: selectedMenus,
      });

      toast.success("Role updated successfully");
    } catch {
      toast.error("Failed to update role");
    }
  };

  const handleSaveCreate = async () => {
    if (!newRoleName.trim()) {
      toast.error("Role name is required");
      return;
    }

    try {
      await api.post("/api/roles/create-with-menus", {
        role: newRoleName,
        menus: selectedMenus,
      });

      toast.success("Role created successfully");
      setIsCreateMode(false);
      fetchInitialData();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create role");
    }
  };

  if (loading) {
    return (
      <MainLayout sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} title="Preferences" subtitle="Manage user roles and permissions">
        <div style={{ padding: 40 }}>Loading...</div>
      </MainLayout>
    );
  }

  return (
    <MainLayout sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} title="Preferences" subtitle="Manage user roles and permissions">
      
      {/* TOP NAVBAR is now handled by MainLayout */}

    <div style={backgroundLayer}>
        <div className="preferences-background">
      <div style={pageWrapper}>
        {/* LEFT PANEL */}
        <div style={rolePanel}>
          <div style={panelHeader}>Roles</div>

          <div style={roleList}>
            {roles.map((role) => (
              <div
                key={role.role_id}
                style={{
                  ...roleItem,
                  ...(selectedRole === role.role_name
                    ? activeRoleItem
                    : {}),
                }}
                onClick={() => handleRoleClick(role.role_name)}
              >
                {role.role_name}
              </div>
            ))}

            <div style={createRoleBtn} onClick={handleCreateClick}>
              + Create Role
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div style={permissionPanel}>
          {(selectedRole || isCreateMode) ? (
            <>
              <div style={permissionHeader}>
                {isCreateMode
                  ? "Create New Role"
                  : `Edit Permissions – ${selectedRole}`}
              </div>

              {isCreateMode && (
                <input
                  type="text"
                  placeholder="Enter role name"
                  value={newRoleName}
                  onChange={(e) => setNewRoleName(e.target.value)}
                  style={roleInput}
                />
              )}

              <div style={permissionCard}>
                {allMenus.map((menu) => (
                  <div key={menu.menu_id} style={permissionRow}>
                    <div style={menuTitle}>
                      {menu.menu_name}
                    </div>

                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={selectedMenus.includes(menu.menu_name)}
                        onChange={() => handleToggle(menu.menu_name)}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                ))}
              </div>

              <div style={saveBar}>
                <button
                  style={primaryBtn}
                  onClick={isCreateMode ? handleSaveCreate : handleSaveRole}
                >
                  {isCreateMode ? "Create Role" : "Save Changes"}
                </button>
              </div>
            </>
          ) : (
            <div style={emptyState}>
              Select a role to manage permissions
            </div>
          )}
        </div>
      </div>
      </div>
      </div>
    </MainLayout>
  );
}

/* ===================== STYLES ===================== */



const pageWrapper = {
  display: "flex",
  gap: "24px",
  padding: "30px",
};

const rolePanel = {
  width: "260px",
  background: "#ffffff",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  padding: "20px",
};

const panelHeader = {
  fontSize: "18px",
  fontWeight: 600,
  marginBottom: "15px",
};

const roleList = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const roleItem = {
  padding: "10px 12px",
  borderRadius: "8px",
  cursor: "pointer",
  transition: "all 0.2s ease",
};

const activeRoleItem = {
  background: "#eef2ff",
  color: "#3b5bdb",
  fontWeight: 600,
};

const createRoleBtn = {
  marginTop: "10px",
  padding: "10px 12px",
  borderRadius: "8px",
  cursor: "pointer",
  color: "#3b5bdb",
  fontWeight: 500,
};

const permissionPanel = {
  flex: 1,
};

const permissionHeader = {
  fontSize: "22px",
  fontWeight: 600,
  marginBottom: "20px",
};

const roleInput = {
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #ddd",
  marginBottom: "20px",
  width: "300px",
};

const permissionCard = {
  background: "#ffffff",
  borderRadius: "12px",
  padding: "20px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
};

const permissionRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px 0",
  borderBottom: "1px solid #f1f3f5",
};

const menuTitle = {
  fontSize: "15px",
  fontWeight: 500,
};

const saveBar = {
  marginTop: "20px",
  textAlign: "right",
};

const primaryBtn = {
  background: "#3b5bdb",
  color: "#fff",
  border: "none",
  padding: "10px 24px",
  borderRadius: "8px",
  cursor: "pointer",
};

const emptyState = {
  background: "#ffffff",
  padding: "40px",
  borderRadius: "12px",
  textAlign: "center",
  color: "#888",
  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
};

const backgroundLayer = {
  minHeight: "calc(100vh - 64px)",
  paddingTop: "20px",

  /* Premium soft background */
  background: "linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)",

  /* Optional subtle pattern effect */
  position: "relative",
};